import { EffectCallback, useEffect } from '../../react';

type UseEffectOnceOutput = void;

export const useEffectOnce = (effect: EffectCallback): UseEffectOnceOutput => {
   // eslint-disable-next-line react-hooks/exhaustive-deps
   return useEffect(effect, []);
};
